import { Component, Input } from '@angular/core';
import { NavController, NavParams, AlertController, LoadingController } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';
import { Globals } from '../../../../globals';
import { ProductsServices } from '../../services';
import { debounceTime } from 'rxjs/operators';
import { AIServices } from "../../../services/aiServices";

@Component({
    selector: 'page-product-create-partial-name',
    templateUrl: 'product-create-partial-name.html',
})
export class ProductCreatePartialNamePage {
    @Input() update_state;

    show_list: boolean = false;
    es: any;
    en: any;
    it: any;
    de: any;
    fr: any;
    ca: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,
        public http: HttpClient,
        public alertCtrl: AlertController,
        public productsServices: ProductsServices,
        public loadingCtrl: LoadingController,
        public aiServices: AIServices) {

    }

    ngOnInit() {
        this.es = this.productsServices.form.value.name;
        this.en = this.productsServices.form.value.name_en;
        this.fr = this.productsServices.form.value.name_fr;
        this.it = this.productsServices.form.value.name_it;
        this.de = this.productsServices.form.value.name_de;
        this.ca = this.productsServices.form.value.name_ca;

        this.productsServices.form
            .get(this.returnName())
            .valueChanges
            .pipe(
                debounceTime(300),
            )
            .subscribe(data => {
                if (this.returnNameContent() != '') {
                    this.show_list = true;
                    this.updateDefaultNames();
                }
            })
    }

    private updateDefaultNames() {
        const mainName = this.returnNameContent();
        if (!mainName) return;

        if (this.globals.restaurant.lang !== 'en' && !this.productsServices.form.value.name_en) {
            this.productsServices.form.patchValue({ name_en: mainName });
        }
        if (this.globals.restaurant.lang !== 'es' && !this.productsServices.form.value.name) {
            this.productsServices.form.patchValue({ name: mainName });
        }
        if (this.globals.restaurant.lang !== 'fr' && !this.productsServices.form.value.name_fr) {
            this.productsServices.form.patchValue({ name_fr: mainName });
        }
        if (this.globals.restaurant.lang !== 'de' && !this.productsServices.form.value.name_de) {
            this.productsServices.form.patchValue({ name_de: mainName });
        }
        if (this.globals.restaurant.lang !== 'it' && !this.productsServices.form.value.name_it) {
            this.productsServices.form.patchValue({ name_it: mainName });
        }
        if (this.globals.restaurant.lang !== 'ca' && !this.productsServices.form.value.name_ca) {
            this.productsServices.form.patchValue({ name_ca: mainName });
        }
    }

    returnName() {
        switch (this.globals.restaurant.lang) {
            case 'es': {
                return 'name';
            }
            case 'en': {
                return 'name_en';
            }
            case 'fr': {
                return 'name_fr';
            }
            case 'de': {
                return 'name_de';
            }
            case 'it': {
                return 'name_it';
            }
            case 'ca': {
                return 'name_ca';
            }
        }
    }

    returnNameContent() {
        switch (this.globals.restaurant.lang) {
            case 'es': {
                return this.productsServices.form.value.name;
            }
            case 'en': {
                return this.productsServices.form.value.name_en;
            }
            case 'fr': {
                return this.productsServices.form.value.name_fr;
            }
            case 'de': {
                return this.productsServices.form.value.name_de;
            }
            case 'it': {
                return this.productsServices.form.value.name_it;
            }
            case 'ca': {
                return this.productsServices.form.value.name_ca;
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/pages/products/product-create/product-create-partial-name/product-create-partial-name.ts